import Card from '@mui/material/Card'
import { Formik } from 'formik'
import React, { useCallback, useState } from 'react'
import * as Yup from 'yup'

import { Event as EventApi, FormEvent as FormEventApi } from '../../../../API'
import FormComponent from '../../../../components/forms/elements/Form'
import FormButton from '../../../../components/forms/elements/FormButton'
import FormButtonContainer from '../../../../components/forms/elements/FormButtonContainer'
import FormGrid from '../../../../components/forms/elements/FormGrid'
import content from '../form/content'
import manualContent from '../form/manualContent'
import schema from '../form/schema'

interface Props {
  events: Array<Event | FormEvent>
  onSubmit: (values: Yup.InferType<typeof schema>) => void
  loading: boolean
}

type Event = Omit<Exclude<EventApi, null>, '__typename'>
type FormEvent = Omit<Exclude<FormEventApi, null>, '__typename'>

const Form: React.FC<Props> = ({ events, onSubmit, loading }) => {
  const [formLoading, setFormLoading] = useState(false)

  const handleSubmit = useCallback(
    async (values: Yup.InferType<typeof schema>) => {
      setFormLoading(true)
      onSubmit(values)
      setFormLoading(false)
    },
    [onSubmit],
  )

  return (
    <>
      {events && (
        <Formik
          initialValues={{
            eventId: null,
          }}
          validateOnMount={true}
          enableReinitialize
          validationSchema={schema}
          onSubmit={handleSubmit}>
          {(form) => {
            return (
              <FormComponent>
                <Card>
                  <FormGrid
                    content={content({
                      formDisabled: form.isSubmitting || formLoading,
                      events,
                    })}
                  />
                </Card>
                <FormButtonContainer wrap={false}>
                  <></>
                  <FormButton
                    submit
                    primary
                    outlined
                    disabled={!form.isValid || form.isSubmitting || loading}
                    loading={loading}>
                    Download
                  </FormButton>
                </FormButtonContainer>
              </FormComponent>
            )
          }}
        </Formik>
      )}
      <Formik
        initialValues={{
          eventId: null,
        }}
        validateOnMount={true}
        enableReinitialize
        validationSchema={schema}
        onSubmit={handleSubmit}>
        {(form) => {
          return (
            <FormComponent>
              <Card>
                <FormGrid
                  content={manualContent({
                    formDisabled: form.isSubmitting || formLoading,
                  })}
                />
              </Card>
              <FormButtonContainer wrap={false}>
                <></>
                <FormButton
                  submit
                  primary
                  outlined
                  disabled={!form.isValid || form.isSubmitting || loading}
                  loading={loading}>
                  Download
                </FormButton>
              </FormButtonContainer>
            </FormComponent>
          )
        }}
      </Formik>
    </>
  )
}

export default Form
